import { _ as __makeTemplateObject, u as useCogniteContext, f as __read, b as __awaiter, e as __generator } from '../../chunks/chunk-525a49bc.js';
import { Icon, Breadcrumb } from 'antd';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT } from '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';

var ENTER_KEY_CODE = 13;
var renderBreadcrumbs = function (assets, renderAsset, maxLength) {
    if (maxLength === void 0) { maxLength = 7; }
    var gapBreadcrumb = (React.createElement(Breadcrumb.Item, { key: '...' },
        React.createElement(BreadcrumbSpan, null, "...")));
    var assetsToRender = assets.slice();
    if (assets.length > maxLength) {
        assetsToRender.splice(maxLength - 1, assets.length - maxLength);
    }
    var renderedList = assetsToRender.map(function (asset, assetIndex) { return (React.createElement(Breadcrumb.Item, { key: asset.id || assetIndex }, renderAsset(asset, assetIndex))); });
    if (assets.length > maxLength) {
        renderedList.splice(1, 0, gapBreadcrumb);
    }
    return renderedList;
};
/**
 * Component AssetBreadcrumb
 * @param assetId: number
 * @param maxLength: number = 3
 * @param renderItem: (asset: Asset, depth: number) => JSX.Element;
 * @param onBreadcrumbClick: (asset: Asset, depth: number) => void;
 * @constructor
 */
var AssetBreadcrumb = function (_a) {
    var assetId = _a.assetId, _b = _a.maxLength, maxLength = _b === void 0 ? 3 : _b, renderItem = _a.renderItem, retrieveAsset = _a.retrieveAsset, _c = _a.onBreadcrumbClick, onBreadcrumbClick = _c === void 0 ? function () { return undefined; } : _c;
    var context = useCogniteContext(Component);
    var _d = __read(useState([]), 2), assets = _d[0], setAssets = _d[1];
    var _e = __read(useState(true), 2), isLoading = _e[0], setIsLoading = _e[1];
    var fetchAsset = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, asset, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!retrieveAsset) return [3 /*break*/, 2];
                    return [4 /*yield*/, retrieveAsset(id)];
                case 1:
                    _b = [_c.sent()];
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, context.assets.retrieve([{ id: id }])];
                case 3:
                    _b = _c.sent();
                    _c.label = 4;
                case 4:
                    _a = __read.apply(void 0, [_b, 1]), asset = _a[0];
                    return [2 /*return*/, asset];
            }
        });
    }); };
    var renderValue = function (asset, index) {
        if (renderItem) {
            return renderItem(asset, index);
        }
        return (React.createElement(BreadcrumbSpan, { tabIndex: 0, role: "button", onClick: function () { return onBreadcrumbClick(asset, index); }, onKeyDown: function (e) {
                return e.keyCode === ENTER_KEY_CODE && onBreadcrumbClick(asset, index);
            } }, asset.name || asset.id));
    };
    useEffect(function () {
        var canceled = false;
        if (!context) {
            console.error(ERROR_NO_SDK_CLIENT);
            return;
        }
        var generateAssetChain = function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var assetChain, asset, rootAsset, rootId;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        assetChain = [];
                        setIsLoading(true);
                        return [4 /*yield*/, fetchAsset(id)];
                    case 1:
                        asset = _b.sent();
                        rootAsset = null;
                        rootId = asset.rootId;
                        assetChain.push(asset);
                        _b.label = 2;
                    case 2:
                        if (!(asset.parentId && !canceled)) return [3 /*break*/, 8];
                        if (!(asset.id !== id && asset.parentId === rootId)) return [3 /*break*/, 3];
                        return [3 /*break*/, 8];
                    case 3:
                        if (!(asset.id === id && asset.parentId !== rootId)) return [3 /*break*/, 5];
                        return [4 /*yield*/, Promise.all([
                                fetchAsset(rootId),
                                fetchAsset(asset.parentId),
                            ])];
                    case 4:
                        _a = __read.apply(void 0, [_b.sent(), 2]), rootAsset = _a[0], asset = _a[1];
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, fetchAsset(asset.parentId)];
                    case 6:
                        asset = _b.sent();
                        _b.label = 7;
                    case 7:
                        assetChain.push(asset);
                        return [3 /*break*/, 2];
                    case 8:
                        if (canceled) {
                            return [2 /*return*/];
                        }
                        if (rootAsset) {
                            assetChain.push(rootAsset);
                        }
                        assetChain.reverse();
                        setAssets(assetChain);
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        generateAssetChain(assetId);
        return function () {
            canceled = true;
        };
    }, [assetId]);
    return isLoading ? (React.createElement(Icon, { type: "loading" })) : (React.createElement(BreadcrumbWrapper, null,
        React.createElement(Breadcrumb, null, renderBreadcrumbs(assets, renderValue, maxLength))));
};
var BreadcrumbWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-breadcrumb-separator {\n    margin: 0 8px;\n    color: rgba(0, 0, 0, 0.45);\n  }\n"], ["\n  .ant-breadcrumb-separator {\n    margin: 0 8px;\n    color: rgba(0, 0, 0, 0.45);\n  }\n"])));
var BreadcrumbSpan = styled("span")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var Component = withDefaultTheme(AssetBreadcrumb);
Component.displayName = 'AssetBreadcrumb';
var templateObject_1, templateObject_2;

export { Component as AssetBreadcrumb };
